import { render, staticRenderFns } from "./secondTravelCateList.vue?vue&type=template&id=704fc698&scoped=true&"
import script from "./secondTravelCateList.vue?vue&type=script&lang=js&"
export * from "./secondTravelCateList.vue?vue&type=script&lang=js&"
import style0 from "./secondTravelCateList.vue?vue&type=style&index=0&id=704fc698&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fc698",
  null
  
)

export default component.exports